import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import * as Chart from 'chart.js';
import { AVAILABLE_PLANS } from '../../constants/code-constants';
import { monthNames } from '../../constants/code-constants';
import { REVENUE } from 'src/app/interfaces/interface';

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.scss']
})

export class RevenueComponent implements OnInit {
  public revenueReport = {
    totalPlansRevenue: 0,
    totalSubscriptions: 0,
    totalPremiumPlanRevenue: 0,
    totalPlusPlanRevenue: 0,
    totalBoostPlanRevenue: 0,
    totalSuperLikePlanRevenue: 0,
    totalSeeWhoLikeYouPlanRevenue: 0,
    totalboost24HrsPlanRevenue: 0
  };
  public chart: any;
  public currentDate = new Date();
  public curmonth: string = (this.currentDate.getMonth() + 1).toString();
  public curyear: any = (this.currentDate.getFullYear()).toString();
  public monthName: any = [];
  public years: any = [];
  public selectedOptionforRev = 'bar';
  public showRevenue = '0';
  public revenueByCurrency: { [currency: string]: number } = {};
  public baseRevenue: number = 0;
  public exchangeRate: number = 1;
  public exchangeRates: { [currency: string]: number } = { USD: 1 };
  public premiumPlans: Array<any> = [];
  public plusPlans: Array<any> = [];
  public boostPlans: Array<any> = [];
  public superLikePlans: Array<any> = [];
  public seeWhoLikeYouPlans: Array<any> = [];
  public boost24HrsPlans: Array<any> = [];
  public dropdownPlanIds: Array<string> = AVAILABLE_PLANS;
  public subscriptionPlansWithRevenue: Array<REVENUE> = [];
  public subscriptionPlans: Array<REVENUE> = [];
  public revenueReportForm: FormGroup;
  public allSubscriptionPlanList: Array<Object>;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              private http: HttpClient
  ) {
    const newDate = new Date();
    this.curmonth = (newDate.getMonth() + 1).toString();
  }
  ngOnInit(): void {
    // this.fetchExchangeRate();
    this.getUpdatedMonthYears();
    this.generateRevenueForm();
    this.authenticationService.subscriptionPlansList().subscribe((res: any) => {
      this.allSubscriptionPlanList = res.data;
      this.authenticationService.getRevenueReport(this.curmonth, this.curyear).subscribe((response: any) => {
        const revenuePayload = this.extractRevenuePayload(response);
        this.revenueByCurrency = revenuePayload.revenueByCurrency;
        const revenueMap = Object.keys(revenuePayload.planRevenue).length
          ? revenuePayload.planRevenue
          : revenuePayload.transactionRevenue || {};
        this.subscriptionPlansWithRevenue = this.buildRevenueRowsFromMap(revenueMap, this.allSubscriptionPlanList || []);
        this.subscriptionPlans = this.subscriptionPlansWithRevenue;
        this.baseRevenue = revenuePayload.totalRevenue;
        this.revenueReport.totalPlansRevenue = this.getDollarRevenue(this.baseRevenue);
        this.updateDisplayedRevenue();
        this.revenueReport.totalSubscriptions = this.subscriptionPlansWithRevenue.length;
        this.revenueReport.totalPremiumPlanRevenue = revenuePayload.premiumPlanRevenue;
        this.revenueReport.totalPlusPlanRevenue = revenuePayload.plusPlanRevenue;
        this.revenueReport.totalBoostPlanRevenue = revenuePayload.boostPlanRevenue;
        this.revenueReport.totalSuperLikePlanRevenue = revenuePayload.superLikePlanRevenue;
        this.revenueReport.totalSeeWhoLikeYouPlanRevenue = revenuePayload.seeWhoLikeYouPlanRevenue;
        this.revenueReport.totalboost24HrsPlanRevenue = revenuePayload.boost24HrsPlanRevenue;
        if (this.subscriptionPlansWithRevenue.length) {
          this.createChart('bar');
        }
      });
    });
  }

  private fetchExchangeRate(): void {}
   public filterAllPlans(value: number){
     this.subscriptionPlansWithRevenue = [];
     const month = this.revenueReportForm.get('month').value;
     const year = this.revenueReportForm.get('year').value;
     this.authenticationService.getRevenueReport(month, year).subscribe((response: any) => {
      const revenuePayload = this.extractRevenuePayload(response);
      this.revenueByCurrency = revenuePayload.revenueByCurrency;
      const revenueMap = Object.keys(revenuePayload.planRevenue).length
        ? revenuePayload.planRevenue
        : revenuePayload.transactionRevenue || {};
      this.subscriptionPlansWithRevenue = this.buildRevenueRowsFromMap(revenueMap, this.allSubscriptionPlanList || []);
      this.subscriptionPlans = this.subscriptionPlansWithRevenue;
      this.baseRevenue = revenuePayload.totalRevenue;
      this.revenueReport.totalPlansRevenue = this.getDollarRevenue(this.baseRevenue);
      this.updateDisplayedRevenue();
      this.revenueReport.totalSubscriptions = this.subscriptionPlansWithRevenue.length;
      this.revenueReport.totalPremiumPlanRevenue = revenuePayload.premiumPlanRevenue;
      this.revenueReport.totalPlusPlanRevenue = revenuePayload.plusPlanRevenue;
      this.revenueReport.totalBoostPlanRevenue = revenuePayload.boostPlanRevenue;
      this.revenueReport.totalSuperLikePlanRevenue = revenuePayload.superLikePlanRevenue;
      this.revenueReport.totalSeeWhoLikeYouPlanRevenue = revenuePayload.seeWhoLikeYouPlanRevenue;
      this.revenueReport.totalboost24HrsPlanRevenue = revenuePayload.boost24HrsPlanRevenue;
      if (this.subscriptionPlansWithRevenue.length){
        this.createChart('bar');
      }
    });
   }

   public updateExchangeRate(event: any): void {}

   private updateDisplayedRevenue(): void {
     this.showRevenue = `$${this.getDollarRevenue(this.baseRevenue).toLocaleString('en-US', {
       minimumFractionDigits: 2,
       maximumFractionDigits: 2
     })}`;
   }

   private getDollarRevenue(fallbackRevenue: number): number {
     return Number(fallbackRevenue) || 0;
   }

  public createChart( type: string): void {
     const lables = this.setChartLables();
     this.chart = new Chart('myChart', {
      type,
      data: {
        labels: lables.xAxisValue,
        datasets: [{
          label: `Revenue from ${lables.value} Subscriptions`,
          data: lables.yAxisValue,
          backgroundColor: [
            'rgba(243, 86, 86, 0.8)', // Basic1
            'rgba(209, 150, 49, 0.8)', // Basic2
            'rgba(174, 209, 29, 0.8)', // Basic3
            'rgba(37, 198, 187, 0.8)', // Premium1
            'rgba(98, 108, 4, 0.8)', // Premium2
            'rgba(10, 128, 241, 0.8)', // Premium3
            'rgba(151, 127, 151, 0.8)', // Plus1
            'rgba(19, 17, 44, 0.8)', // Plus2
            'rgba(194, 171, 21, 0.8)', // Plus3
            'rgba(255, 98, 0, 0.8)', // 1_bbost
            'rgba(1, 34, 92, 0.8)', // boost_10
            'rgba(238, 70, 255, 0.8)', // boost_20
            'rgba(173, 71, 255, 0.8)', // superlike1
            'rgba(130, 91, 255, 0.8)', // superlike2
            'rgba(105, 140, 255, 0.8)', // superlike3
            'rgba(70, 194, 255, 0.8)', // seeWhoLikeYou1
            'rgba(38, 230, 255, 0.8)', // seeWhoLikeYou2
            'rgba(0, 255, 214, 0.8)', // seeWhoLikeYou3
            'rgba(0, 214, 126, 0.8)' // boost24Hrs
          ],
          borderColor: [
            'rgba(243, 86, 86, 0.8)', // Basic1
            'rgba(209, 150, 49, 0.8)', // Basic2
            'rgba(174, 209, 29, 0.8)', // Basic3
            'rgba(37, 198, 187, 0.8)', // Premium1
            'rgba(98, 108, 4, 0.8)', // Premium2
            'rgba(10, 128, 241, 0.8)', // Premium3
            'rgba(151, 127, 151, 0.8)', // Plus1
            'rgba(19, 17, 44, 0.8)', // Plus2
            'rgba(194, 171, 21, 0.8)', // Plus3
            'rgba(255, 98, 0, 0.8)', // 1_bbost
            'rgba(1, 34, 92, 0.8)', // boost_10
            'rgba(238, 70, 255, 0.8)', // boost_20
            'rgba(173, 71, 255, 0.8)', // superlike1
            'rgba(130, 91, 255, 0.8)', // superlike2
            'rgba(105, 140, 255, 0.8)', // superlike3
            'rgba(70, 194, 255, 0.8)', // seeWhoLikeYou1
            'rgba(38, 230, 255, 0.8)', // seeWhoLikeYou2
            'rgba(0, 255, 214, 0.8)', // seeWhoLikeYou3
            'rgba(0, 214, 126, 0.8)' // boost24Hrs
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        events: [],
        plugins: {
          tooltip: {
            events: ['click']
          }
        }
      }
    });
  }

  public setChartLables(){
    const value = this.revenueReportForm.get('plans').value;
    const xAxisValue = [];
    const yAxisValue = [];
    this.subscriptionPlans.forEach((plans) => {
         xAxisValue.push(plans.childPlanId);
         yAxisValue.push(plans.revenue);
       });
    return {xAxisValue, yAxisValue, value};
  }

  public onOptionSelectedForRev(value: string) {
    this.selectedOptionforRev = value;
    this.createChart(this.selectedOptionforRev);
  }

  public getUpdatedMonthYears() {
    this.monthName = monthNames;
    for (let i = 2019; i <= this.curyear; i++) {
      this.years.push(i);
    }
  }

  private normalizeRevenueKey(value: any): string {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }

  private getTransactionPlanId(transaction: any): string {
    const basePlanId = String(transaction && transaction.basePlanId || '').trim();
    const normalizedBasePlanId = this.normalizeRevenueKey(basePlanId);
    const genericPlanIds = ['default', 'legacy_base', 'unknown', 'other', 'undefined', 'null'];

    if (genericPlanIds.indexOf(normalizedBasePlanId) === -1 && basePlanId) {
      return basePlanId;
    }

    const transactionKeyParts = String(transaction && transaction.transactionKey || '').split('|');
    return transactionKeyParts.length > 3 && transactionKeyParts[3]
      ? transactionKeyParts[3].trim()
      : basePlanId;
  }

  private formatReadablePlanId(value: any): string {
    const key = this.normalizeRevenueKey(value);
    const readableMap: { [key: string]: string } = {
      android_plus: 'Android Plus',
      one_time_chat_unlock: 'One-time Chat Unlock',
      superlike_2: 'Superlike 2',
      superlike_1: 'Superlike 1',
      plus_17_mo: 'Plus (1 Month)',
      plus_45_3mo: 'Plus (3 Months)',
      plus_80_6mo: 'Plus (6 Months)',
      premium_1_mo: 'Premium (1 Month)',
      premium_3_mo: 'Premium (3 Months)',
      premium_6_mo: 'Premium (6 Months)',
      boost_1: 'Boost 1',
      boost_10: 'Boost 10',
      boost_20: 'Boost 20',
      default: 'Default Plan',
      legacy_base: 'Legacy Base',
      unknown: 'Unknown Plan'
    };

    if (!key) {
      return 'Unknown Plan';
    }

    return readableMap[key] || String(value || 'Unknown Plan');
  }

  private getRevenueFromMatchMap(revenueMap: { [key: string]: any }, candidateKeys: string[]): number {
    if (!revenueMap || !Object.keys(revenueMap).length) {
      return 0;
    }

    const normalizedMap = Object.keys(revenueMap).reduce((acc, key) => {
      acc[this.normalizeRevenueKey(key)] = revenueMap[key];
      return acc;
    }, {} as { [key: string]: any });

    for (const candidate of candidateKeys) {
      const normalizedCandidate = this.normalizeRevenueKey(candidate);
      if (normalizedMap[normalizedCandidate] !== undefined && normalizedMap[normalizedCandidate] !== null) {
        return Number(normalizedMap[normalizedCandidate]) || 0;
      }
    }

    for (const candidate of candidateKeys) {
      const normalizedCandidate = this.normalizeRevenueKey(candidate);
      const match = Object.keys(normalizedMap).find((key) => key.includes(normalizedCandidate) || normalizedCandidate.includes(key));
      if (match) {
        return Number(normalizedMap[match]) || 0;
      }
    }

    return 0;
  }

  private buildRevenueRowsFromMap(revenueMap: { [key: string]: any } = {}, planCatalog: any[] = []): Array<REVENUE> {
    const normalizedMap = Object.keys(revenueMap || {}).reduce((acc, key) => {
      acc[this.normalizeRevenueKey(key)] = Number(revenueMap[key]) || 0;
      return acc;
    }, {} as { [key: string]: number });

    const rows: Array<REVENUE> = [];

    if (planCatalog && planCatalog.length) {
      for (const plan of planCatalog) {
        const planName = plan && plan.planName ? plan.planName : 'Other';
        const planId = plan && plan.planId ? plan.planId : 'other';

        if (plan && Array.isArray(plan.planSchedule)) {
          for (const schedule of plan.planSchedule) {
            const scheduleKey = this.normalizeRevenueKey(schedule && schedule.planId ? schedule.planId : '');
            const key = scheduleKey || this.normalizeRevenueKey(planId);
            const value = normalizedMap[key] !== undefined ? normalizedMap[key] : 0;
            rows.push({
              planName,
              basePlanId: planId,
              childPlanId: schedule && schedule.planId ? String(schedule.planId) : 'N/A',
              revenue: value,
              planDuration: schedule && schedule.planValidity ? String(schedule.planValidity) : 'N/A'
            });
          }
        }
      }

      const extraEntries = Object.keys(normalizedMap).filter((key) => !rows.some((row) => this.normalizeRevenueKey(row.childPlanId) === key));
      for (const extraKey of extraEntries) {
        rows.push({
          planName: this.getRevenuePlanCategory(extraKey),
          basePlanId: this.getRevenuePlanCategory(extraKey),
          childPlanId: this.formatRevenueKeyToPlanName(extraKey),
          revenue: normalizedMap[extraKey],
          planDuration: this.getRevenueDuration(extraKey)
        });
      }

      return rows;
    }

    return Object.keys(normalizedMap).reduce((rowsList, key) => {
      const value = normalizedMap[key] || 0;
      if (!value) {
        return rowsList;
      }

      rowsList.push({
        planName: this.getRevenuePlanCategory(key),
        basePlanId: this.getRevenuePlanCategory(key),
        childPlanId: this.formatRevenueKeyToPlanName(key),
        revenue: value,
        planDuration: this.getRevenueDuration(key)
      });
      return rowsList;
    }, [] as Array<REVENUE>);
  }

  private formatRevenueKeyToPlanName(key: string): string {
    const readableMap: { [key: string]: string } = {
      android_plus: 'Android Plus',
      one_time_chat_unlock: 'One-time Chat Unlock',
      superlike_2: 'Superlike 2',
      superlike_1: 'Superlike 1',
      plus_17_mo: 'Plus (1 Month)',
      plus_45_3mo: 'Plus (3 Months)',
      plus_80_6mo: 'Plus (6 Months)',
      premium_1_mo: 'Premium (1 Month)',
      premium_3_mo: 'Premium (3 Months)',
      premium_6_mo: 'Premium (6 Months)',
      boost_1: 'Boost 1',
      boost_10: 'Boost 10',
      boost_20: 'Boost 20',
      boost_24_hrs: 'Boost 24 Hours',
      boost_24hrs: 'Boost 24 Hours',
      default: 'Default Plan',
      legacy_base: 'Legacy Base',
      spotlight_1_wk: 'Weekly Spotlight',
      spotlight_1wk: 'Weekly Spotlight',
      seewholikey: 'See who like you',
      seewholikey_1: 'See who like you 1 Month',
      seewholikey_3: 'See who like you 3 Months',
      seewholikey_6: 'See who like you 6 Months',
      amaly_2_mo: 'Amaly Extra',
      amaly_extra_2_mo: 'Amaly Extra'
    };

    return readableMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  }

  private getRevenuePlanCategory(key: string): string {
    const normalizedKey = String(key || '').toLowerCase();
    const premiumFamilyKeys = ['plus_17_mo', 'plus_45_3mo', 'plus_80_6mo', 'premium_1_mo', 'premium_3_mo', 'premium_6_mo'];

    const isPremiumFamilyKey = premiumFamilyKeys.indexOf(normalizedKey) !== -1 || normalizedKey.indexOf('premium') !== -1;
    if (isPremiumFamilyKey) return 'Premium';
    if (normalizedKey.includes('basic')) return 'Basic';
    if (normalizedKey.includes('plus') || normalizedKey.includes('android')) return 'Plus';
    if (key.includes('boost')) return 'Boost';
    if (key.includes('superlike')) return 'Superlike';
    if (key.includes('seewholikey') || key.includes('see')) return 'See who like you';
    if (key.includes('amaly')) return 'Amaly Extra';
    if (key.includes('spotlight')) return 'Spotlight';
    if (key.includes('chat')) return 'Chat';
    return 'Other';
  }

  private getRevenueDuration(key: string): string {
    const normalizedKey = String(key || '').toLowerCase();
    if (normalizedKey.includes('17_mo') || normalizedKey.includes('17mo') || normalizedKey.includes('1_mo') || normalizedKey.includes('1_month') || normalizedKey.includes('1wk') || normalizedKey.includes('1_wk')) return '1 Month';
    if (normalizedKey.includes('45_3mo') || normalizedKey.includes('45_3_month') || normalizedKey.includes('3_mo') || normalizedKey.includes('3_month')) return '3 Months';
    if (normalizedKey.includes('80_6mo') || normalizedKey.includes('80_6_month') || normalizedKey.includes('6_mo') || normalizedKey.includes('6_month')) return '6 Months';
    if (key.includes('1_mo') || key.includes('1_month') || key.includes('1wk') || key.includes('1_wk')) return '1 Month';
    if (key.includes('3_mo') || key.includes('3_month')) return '3 Months';
    if (key.includes('6_mo') || key.includes('6_month')) return '6 Months';
    if (key.includes('24_hrs') || key.includes('24hrs')) return '24 Hours';
    if (key.includes('2_mo') || key.includes('2_month')) return '2 Months';
    if (key.includes('wk') || key.includes('week')) return '1 Week';
    if (key.includes('android')) return 'N/A';
    return 'N/A';
  }

  public pushPlanRevenue(planSchedule: any, planId: any, planName: any, revenue: any){
    this.subscriptionPlansWithRevenue = this.buildRevenueRowsFromMap(
      revenue && typeof revenue === 'object' ? revenue : {},
      this.allSubscriptionPlanList || []
    );
  }

  public plansOrder(subscriptionPlans: any, revenue: any){
    for (const plan of subscriptionPlans){
          this.pushPlanRevenue(plan.planSchedule, plan.planId, plan.planName, revenue);
    }
  }

  private sumRevenueByPattern(revenueMap: { [key: string]: any }, patterns: string[]): number {
    if (!revenueMap || !Object.keys(revenueMap).length) {
      return 0;
    }

    return Object.keys(revenueMap).reduce((sum, key) => {
      const normalizedKey = this.normalizeRevenueKey(key);
      const matches = patterns.some((pattern) => {
        const normalizedPattern = this.normalizeRevenueKey(pattern);
        return normalizedKey.includes(normalizedPattern) || normalizedPattern.includes(normalizedKey);
      });

      if (!matches) {
        return sum;
      }

      return sum + (Number(revenueMap[key]) || 0);
    }, 0);
  }

  public extractRevenuePayload(response: any): any {
    const responseData = response && response.data ? response.data : response;
    const planRevenue = responseData && responseData.planRevenue ? responseData.planRevenue : {};
    const revenueByCurrency = responseData && responseData.revenueByCurrency
      ? responseData.revenueByCurrency
      : {};
    const currencyTotals = Object.keys(revenueByCurrency).reduce((totals, currency) => {
      const amount = Number(revenueByCurrency[currency]);
      if (!isNaN(amount)) {
        totals[currency] = amount;
      }
      return totals;
    }, {} as { [currency: string]: number });
    const rawTotalRevenue = responseData && responseData.totalRevenue !== undefined && responseData.totalRevenue !== null
      ? Number(responseData.totalRevenue)
      : 0;
    const currencyTotal = Object.keys(currencyTotals).length === 1
      ? currencyTotals[Object.keys(currencyTotals)[0]]
      : 0;
    const transactions = Array.isArray(responseData && responseData.transactions) ? responseData.transactions : [];
    const transactionRevenue = transactions.reduce((totals, transaction) => {
      if (!transaction) {
        return totals;
      }
      const key = this.getTransactionPlanId(transaction);
      if (!key) {
        return totals;
      }
      const amount = Number(transaction.chargedAmount) || 0;
      totals[key] = (totals[key] || 0) + amount;
      return totals;
    }, {} as { [key: string]: number });
    const planRevenueMap = planRevenue;
    const transactionTotal = Object.keys(transactionRevenue).reduce((sum, key) => sum + (Number(transactionRevenue[key]) || 0), 0);
    const totalRevenue = currencyTotal > 0 ? currencyTotal : (rawTotalRevenue || transactionTotal || 0);

    const premiumPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['premium', 'premium_']);
    const plusPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['plus', 'plus_']);
    const boostPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['boost', 'boost_']);
    const superLikePlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['superlike', 'super_like', 'super_like_']);
    const seeWhoLikeYouPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['see', 'see_who', 'who_like_you']);
    const boost24HrsPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['boost24', 'boost_24', 'boost24hrs', 'boost24_hours']);
    const amalyExtraPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['amaly_extra', 'amaly']);
    const spotlightPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['spotlight']);
    const chatPlanRevenue = this.sumRevenueByPattern(planRevenueMap, ['chat', 'chat_unlock']);

    return {
      planRevenue: planRevenueMap,
      transactionRevenue,
      revenueByCurrency: currencyTotals,
      totalRevenue,
      premiumPlanRevenue,
      plusPlanRevenue,
      boostPlanRevenue,
      superLikePlanRevenue,
      seeWhoLikeYouPlanRevenue,
      boost24HrsPlanRevenue,
      amalyExtraPlanRevenue,
      spotlightPlanRevenue,
      chatPlanRevenue
    };
  }

  private readNumericValue(source: any, keys: string[]): number {
    for (const key of keys) {
      if (source && source[key] !== undefined && source[key] !== null) {
        const value = Number(source[key]);
        return isNaN(value) ? 0 : value;
      }
    }
    return 0;
  }
  public generateRevenueForm(){
    this.revenueReportForm = new FormGroup({
      month: new FormControl(this.curmonth, [Validators.required]),
      year: new FormControl(this.curyear, [Validators.required]),
      plans: new FormControl(this.dropdownPlanIds[0], [Validators.required]),
    });
  }

  public filterPlans(value: string){
     const updatedValue = value.toLocaleLowerCase();
     const filterPlans = (this.subscriptionPlansWithRevenue.filter((plans) => {
      const planId = plans.basePlanId.toLocaleLowerCase();
      return  updatedValue.includes(planId);
    }
    ));
     if (filterPlans.length){
    this.subscriptionPlans = filterPlans;
    }
    else{
    this.subscriptionPlans = this.subscriptionPlansWithRevenue;
    }
     this.createChart(this.selectedOptionforRev);
     this.updatedShowRevenue(value);
  }

  public updatedShowRevenue(value: string){
    if (value === this.dropdownPlanIds[1]){
      this.showRevenue = `$${this.revenueReport.totalPremiumPlanRevenue.toLocaleString('en-US')}`;
    }
    else if (value === this.dropdownPlanIds[2]){
      this.showRevenue = `$${this.revenueReport.totalPlusPlanRevenue.toLocaleString('en-US')}`;
    }
    else if (value === this.dropdownPlanIds[3]){
      this.showRevenue = `$${this.revenueReport.totalBoostPlanRevenue.toLocaleString('en-US')}`;
    }
    else if (value === this.dropdownPlanIds[4]){
      this.showRevenue = `$${this.revenueReport.totalSuperLikePlanRevenue.toLocaleString('en-US')}`;
    }
    else{
      this.updateDisplayedRevenue();
    }
  }
}
